import { render } from "./GoalScorersUcl.vue?vue&type=template&id=1635eb8d"
import script from "./GoalScorersUcl.vue?vue&type=script&lang=js"
export * from "./GoalScorersUcl.vue?vue&type=script&lang=js"

import "./GoalScorersUcl.vue?vue&type=style&index=0&id=1635eb8d&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__